import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./SeriesPage.css";
import RecipeCard from "../components/RecipeCard";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function SeriesPage() {
    const { seriesName } = useParams();
    const [recipes, setRecipes] = useState([]);

    useEffect(() => {
        if (!seriesName) return;

        const fetchRecipes = async () => {
            try {
                const response = await fetch(
                    `${API_BASE_URL}/api/recipes/?series=${encodeURIComponent(seriesName)}`
                );
                const data = await response.json();

                // DRF returns paginated results if pagination enabled
                setRecipes(data.results || data);
            } catch (error) {
                console.error("Error fetching recipes by series:", error);
            }
        };

        fetchRecipes();
    }, [seriesName]);

    return (
        <div className="series-page">
            <h1 className="series-title">{seriesName}</h1>

            <div className="recipes-grid">
                {recipes.length > 0 ? (
                    recipes.map((recipe) => (
                        <RecipeCard key={recipe.id} recipe={recipe} />
                    ))
                ) : (
                    <p>No recipes found for this series.</p>
                )}
            </div>
        </div>
    );
}
